<template>
  <Component
    :is="inDrawer ? DrawerClose : Primitive"
    class="group flex items-center grow p-1 gap-4 hover:bg-alpha-white-10 rounded-xl hover:cursor-pointer transition duration-400 ease-out"
  >
    <div class="flex items-center grow gap-3 max-w-full">
      <Avatar
        :src="user.avatar_url"
        :name="user.fullname"
        :initials="user.avatar_initials"
        size="lg"
        class="before:!shadow-none before:group-hover:!shadow-[inset_0_0_0_1px_rgba(255,255,255,0.2)]"
      />
      <component
        class="text-style-sm font-semibold md:text-white group-hover:underline truncate text-ellipsis shrink group-data-[collapsed=true]/nav:md:hidden max-w-full"
        :is="showNameTooltip ? Tooltip : 'span'"
        ref="nameContainer"
        v-bind="
          showNameTooltip ? { title: user.fullname, triggerAs: 'span' } : {}
        "
      >
        {{ user.fullname }}
      </component>
    </div>
  </Component>
</template>

<script setup>
import { ref, watch } from "vue";
import { Primitive } from "radix-vue";
import { Avatar } from "@/SharedComponents/Avatars";
import { DrawerClose } from "@/SharedComponents/Drawer";
import { Tooltip } from "@/SharedComponents/Tooltips";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { width } = useBreakpoints();

defineProps({
  user: { type: Object, required: true },
  inDrawer: { type: Boolean, required: false },
});

const nameContainer = ref(null);
const showNameTooltip = ref(false);

let tooltipTimeout = null;
const calculateNameTooltip = () => {
  if (tooltipTimeout) clearTimeout(tooltipTimeout);
  tooltipTimeout = setTimeout(() => {
    showNameTooltip.value =
      nameContainer?.value?.scrollWidth > nameContainer?.value?.offsetWidth;
  }, 500);
};

watch(
  () => width.value,
  () => {
    calculateNameTooltip();
  },
  { immediate: true }
);
</script>
